/**
 * 首屏顶部的欢迎横幅：告诉用户「读到了哪张表、下一步是什么」。
 * 以前是一块带表 ID 的技术感条，用户看不懂 tbl 开头那串是什么。
 */
import { Segmented, Tooltip } from 'antd';
import { AppstoreOutlined, BookOutlined, ReloadOutlined } from '@ant-design/icons';
import type { AppMode } from '../../store/reducer';
import type { TableContext } from '../../api/types';

interface Props {
  context: TableContext | null;
  tableName: string | null;
  mode: AppMode;
  onModeChange: (mode: AppMode) => void;
  onRefresh: () => void;
  /** 只有存量「视图模板」的用户才看得到模式切换。新用户只有一种模板。 */
  showModeSwitch?: boolean;
}

export function ContextStrip({ context, tableName, mode, onModeChange, onRefresh, showModeSwitch }: Props) {
  const name = tableName || context?.tableId || null;
  return (
    <div style={{ padding: '12px 16px 0' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          padding: '12px 14px',
          borderRadius: 10,
          background: 'var(--accent-soft)',
          border: '1px solid rgba(188, 90, 50, .18)',
        }}
      >
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 13.5, fontWeight: 700, color: 'var(--ink)' }}>欢迎使用 AI 排版打印</div>
          <div style={{ fontSize: 12, color: 'var(--ink-2)', marginTop: 3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {name ? (
              <>
                已读取「{name}」，选好版式即可预览真实数据
              </>
            ) : (
              '未连接数据表，请在多维表格里打开本插件'
            )}
          </div>
        </div>
        <Tooltip title="重新读取当前数据表">
          <button
            className="pp-bare-button"
            onClick={onRefresh}
            style={{ color: 'var(--ink-3)', padding: 4, borderRadius: 6, flexShrink: 0 }}
            aria-label="刷新"
          >
            <ReloadOutlined style={{ fontSize: 13 }} />
          </button>
        </Tooltip>
      </div>
      {showModeSwitch && (
        <Segmented
          block
          size="small"
          style={{ marginTop: 10 }}
          value={mode}
          onChange={(v) => onModeChange(v as AppMode)}
          options={[
            {
              value: 'contract',
              label: (
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}>
                  <BookOutlined style={{ fontSize: 12 }} />
                  记录模板
                </span>
              ),
            },
            {
              value: 'table',
              label: (
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}>
                  <AppstoreOutlined style={{ fontSize: 12 }} />
                  视图模板
                </span>
              ),
            },
          ]}
        />
      )}
    </div>
  );
}
